import styled from "styled-components";
import theme from "../../style/theme";
import RadioActiveIcon from "../icons/RadioActiveIcon";
import RadioInActiveIcon from "../icons/RadioInActiveIcon";

interface Props {
    isActive: boolean;
    onClick: () => void;
    title: string;
    content: string;
    disabled?: boolean;
    disabledReason?: string;
}

export const OptimizationTypeRadioButton: React.FC<Props> = (
    {
        isActive,
        onClick,
        title,
        content,
        disabled,
        disabledReason,
    }
) => {
    return (
        <Container isActive={isActive && !disabled} onClick={disabled ? undefined : onClick} disabled={disabled}>
            <LeftContent>
                {isActive && !disabled ? (
                    <RadioActiveIcon fill={theme.palette.primitives.yellow400}/>
                ) : (
                    <RadioInActiveIcon fill={theme.palette.primitives.gray200}/>
                )}
            </LeftContent>
            <RightContent>
                <RightContentLabel1 isActive={isActive && !disabled}>
                    {title}
                </RightContentLabel1>
                <RightContentLabel2>
                    {content}
                </RightContentLabel2>
                {disabled && disabledReason && (
                    <DisabledReason>{disabledReason}</DisabledReason>
                )}
            </RightContent>
        </Container>
    );
};

interface ContainerProps {
    isActive: boolean;
    disabled?: boolean;
}

const Container = styled.div<ContainerProps>`
  width: fit-content;
  height: 69px;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  padding: 16px;
  display: flex;
  flex-direction: row;
  border-radius: 6px;
  border: 1px solid ${(props) =>
          props.isActive
                  ? theme.palette.primitives.yellow400
                  : theme.palette.primitives.gray200};
  background: ${(props) =>
          props.disabled ? theme.palette.primitives.gray50 : props.isActive ? theme.palette.primitives.yellow50 : "#ffffff"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => props.disabled ? theme.palette.primitives.gray50 : props.isActive ? theme.palette.primitives.yellow50 : theme.palette.primitives.gray50};
  }
`;

const LeftContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 12px 0 0;
  box-sizing: border-box;
`;

const RightContent = styled.div`
  width: fit-content;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
`;

interface RightContentLabel1Props {
    isActive: boolean;
}

const RightContentLabel1 = styled.div<RightContentLabel1Props>`
  width: fit-content;
  height: 19px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: ${(props) => (props.isActive ? 600 : 500)};
  color: ${(props) =>
          props.isActive ? "#68440d" : theme.palette.primitives.gray500};
`;

const RightContentLabel2 = styled.div`
  width: fit-content;
  height: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.palette.primitives.gray400};
  font-style: normal;
  line-height: normal;
  font-feature-settings: "clig" off, "liga" off;
`;

const DisabledReason = styled.div`
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 400;
  color: ${theme.palette.primitives.gray400};
  margin-top: 2px;
`;
